import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import NumericPad from "../../common/NumericPad.jsx";
import { apiService } from "../../../../services/apiService.ts";

export default function StaffPinModal({ isOpen, onClose, onApproved }) {
  const [pin, setPin] = useState("");
  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);

  // Reset state when opened
  useEffect(() => {
    if (isOpen) {
      setPin("");
      setErrorText("");
      setLoading(false);
    }
  }, [isOpen]);

  const attemptAuth = async () => {
    if (pin.length !== 4 || loading) return;

    setLoading(true);
    try {
      const resp = await apiService.staffLogin(Number(pin));

      if (!resp.Success || !resp.Data?.StaffID) {
        setErrorText("Invalid PIN. Please try again.");
        setPin("");
        setLoading(false);
        return;
      }

      onApproved(resp.Data);
    } catch (ex) {
      setErrorText("Unexpected error.");
      setPin("");
    } finally {
      setLoading(false);
    }
  };

  // Auto submit when PIN reaches 4 digits
  useEffect(() => {
    if (pin.length === 4) attemptAuth();
  }, [pin]);

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block pos-modal"
      style={{
        background: "rgba(0,0,0,0.55)",
        zIndex: 40000
      }}
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg">

          {/* HEADER */}
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title fw-semibold">Staff PIN</h5>
            <button className="btn btn-light" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body text-center">

            {/* Loading overlay */}
            {loading && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 40001,
                  borderRadius: "12px"
                }}
              >
                <div className="spinner-border text-primary"></div>
              </div>
            )}

            <input
              type="password"
              className="form-control mb-2"
              placeholder="Enter PIN"
              value={"•".repeat(pin.length)}
              maxLength={4}
              autoFocus
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "").slice(0, 4);
                setPin(digits);
                setErrorText("");
              }}
              style={{
                textAlign: "center",
                fontSize: "1.7rem",
                padding: "12px",
                borderRadius: "10px",
                background: "#fff8cc",
                letterSpacing: "6px",
              }}
            />

            {errorText && <div className="text-danger small">{errorText}</div>}

            <NumericPad value={pin} onChange={(val) => setPin(val.slice(0, 4))} />
          </div>

        </div>
      </div>
    </div>
  );
}
